import React from "react";

export const ConsolidationOrderTargets = React.createContext({ ids: new Set(), arrival: "" });

export function useConsolidationOrderScroll(ref, ready, arrival, active) {
  const completed = React.useRef("");
  React.useEffect(() => {
    if (!ready || !active || completed.current === arrival || !ref.current) return;
    let frame, observer;
    const position = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { frame = requestAnimationFrame(() => {
        const target = ref.current?.querySelector('[data-consolidation-target-delivery="true"]')
          || ref.current?.querySelector('[data-consolidation-target-unassigned="true"]');
        if (target) {
          target.scrollIntoView({ block: "center", inline: "nearest" });
          completed.current = arrival;
          observer?.disconnect();
        }
      }); });
    };
    observer = new MutationObserver(position);
    observer.observe(ref.current, { childList: true, subtree: true });
    position();
    return () => { observer.disconnect(); cancelAnimationFrame(frame); };
  }, [ref, ready, arrival, active]);
}
